import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListChargePointIdentityCell } from './channel-list-charge-point-identity.cell';
import { ChannelListChargePointIdentityHeader } from './channel-list-charge-point-identity.header';

export const ChannelListChargePointIdentityColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['chargePointIdentity']
> = {
  enableSorting: false,
  header: ChannelListChargePointIdentityHeader,
  cell: ChannelListChargePointIdentityCell,
};
